export default {
  General: {
    NonSkippable: 'General question: non-skippable',
    WhyCaregiver: 'Why did you become a caregiver?',
    OutsideWork: 'What do you do outside of work?',
    BestClients: 'What type of clients do you work best with?',
    PersonalGoals: 'What are your personal goals for the next year?',
    WhyChooseYou: 'Why would someone choose you to be their caregiver?',
  },
  Skills: {
    Dementia: [
      'Dementia Care Question: skip if user fails to adequately answer this question',
      'Can you tell me about a time you supported someone living with dementia? What was a typical day like?',
      'Describe a moment when the person became confused, anxious, or upset. What happened, and how did you respond?',
      'Looking back, what did you learn about what helped calm or reassure them in those situations?',
    ],
    Parkinson: [
      'Parkinson\'s Disease Care Question: skip if user fails to adequately answer this question',
      'Think of a client with Parkinson’s you’ve supported. What kind of daily challenges did they face?',
      'Tell me about a time you needed to help them with mobility or medication management. How did you approach it?',
      'What adjustments did you notice were most effective over time, and how did you figure those out?',
    ],
    Stroke: [
      'Stroke Care Question: skip if user fails to adequately answer this question',
      'Can you share a story about helping someone after a stroke? What stage of recovery were they in?',
      'Was there a time when you had to encourage or support them through frustration with rehabilitation? How did you handle it?',
      'How did you know your approach was helping — what changes did you see in them?',
    ],
    Diabetes: [
      'Diabetes Care Question: skip if user fails to adequately answer this question',
      'Have you cared for someone with diabetes? What kinds of routines did you help them with?',
      'Tell me about a time you noticed a change in their condition — maybe low blood sugar, high blood sugar, or something else. What did you do?',
      'What signs do you personally pay close attention to, and why?',
    ],
    COPD: [
      'COPD Care Question: skip if user fails to adequately answer this question',
      'Can you describe your experience supporting someone with COPD or breathing difficulties?',
      'Tell me about a time when their breathing worsened or they had an episode. How did you handle it?',
      'What small daily habits or precautions did you find made the biggest difference for their comfort and safety?',
    ],
    Cancer: [
      'Cancer Care Question: skip if user fails to adequately answer this question',
      'Have you supported someone undergoing chemotherapy? What did your role look like day-to-day?',
      'Can you share a story of when they were especially weak or in pain? How did you help them through it?',
      'What did you learn about supporting their emotional well-being in addition to physical needs?',
    ],
    Palliative: [
      'Palliative Care Question: skip if user fails to adequately answer this question',
      'Can you tell me about someone you cared for at the end of life? What stands out from that time?',
      'Describe a difficult moment for the family or client. How did you support them through it?',
      'What did that experience teach you about balancing dignity, comfort, and emotional support?',
    ],
  },
};
